<template>
  <section class="issue-certificate">
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true"
    />
    <form-header :title="$t('cirurgias.faleconosco.titulo')" />
    <div class="container-sarah">
      <form-steps :steps="steps" :current-step="currentStep" />
      <div class="form-template general-forms" v-if="currentStep === 0">
        <p class="intro">
          Utilize este espaço para tirar dúvidas a respeito da sua cirurgia.
        </p>
        <p>
          {{ cirurgia.DsPrograma }} <br />
          Data da Solicitação da cirurgia:
          {{ cirurgia.DtHrSolicitacao | formatarDataSolicitacao }}<br />
          Nome do Paciente: {{ paciente.Nome }}<br />
          Registro do Paciente: {{ paciente.Prontuario }}<br />
        </p>
        <br />
        <b-field label="Escreva abaixo a sua dúvida">
          <b-input type="textarea" v-model="textInput" maxlength="500" />
        </b-field>
      </div>
      <div v-if="currentStep === 1">
        <div v-if="isSuccess">
          <div class="columns">
            <img
              class="login-section_logo column"
              src="~@/assets/images/banners/doctors_banner.svg"
              alt="Imagem padioleiro com paciente e acompanhante"
            />
            <div class="column">
              <div class="mensagem-sucesso">
                <h1>Mensagem enviada</h1>
                <p>
                  Um e-mail de confirmação foi enviado para o endereço
                  {{ paciente.Email }}.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="columns">
            <img
              class="login-section_logo column"
              src="~@/assets/images/banners/doctors_banner.svg"
              alt="Imagem padioleiro com paciente e acompanhante"
            />
            <div class="column">
              <div class="mensagem-erro" />
            </div>
          </div>
        </div>
      </div>
      <form-footer
        @go-to="sendMessage"
        :disabled="!disabledButton"
        :final-page="statePage"
        :ok-page="statusOk"
        :mult-comp="false"
        :last-comp="currentStep < 1"
        @prev-step="currentStep--"
        :back-button-path="{ name: 'Cirurgias' }"
      />
    </div>
  </section>
</template>

<script>
import FormHeader from '@/components/shared/header/FormHeader'
import FormFooter from '@/components/atestados/FormFooter'
import FormSteps from '@/components/shared/forms/FormSteps'
import CirurgiaService from '../../services/cirurgia-service'
import { mapActions, mapGetters } from 'vuex'
import { format } from 'date-fns'

export default {
  name: 'CirurgiasFaleConosco',
  props: {
    cirurgia: {
      type: Object,
      default: null
    }
  },
  components: {
    FormHeader,
    FormSteps,
    FormFooter
  },
  data() {
    return {
      stateTitle: '',
      stateText: '',
      isFullPage: true,
      statusOk: true,
      buttonText: this.$t('botoes.entendi'),
      statePage: false,
      valueSelected: '',
      idSelected: null,
      textInput: '',
      option: { value: this.$t('placeholders.dropdown') },
      commonPlaceholder: this.$t('placeholders.common'),
      dropdown: this.$t('placeholders.dropdown'),
      steps: [{ name: 'Dúvida' }, { name: 'Confirmação de envio' }],
      currentStep: 0,
      isSuccess: true
    }
  },
  computed: {
    ...mapGetters({
      paciente: 'dadosPaciente',
      isLoading: 'isLoading'
    }),
    disabledButton: {
      get() {
        return this.textInput
      },
      set(newValue) {
        let checkButton = newValue
        return checkButton
      }
    }
  },
  methods: {
    ...mapActions(['changeLoadingState']),

    async sendMessage() {
      this.changeLoadingState(true)
      await CirurgiaService.faleConosco(this.cirurgia, this.textInput)
        .then(() => {
          this.currentStep = 1
          this.isSuccess = true
          this.changeLoadingState(false)
        })
        .catch(() => {
          this.currentStep = 1
          this.isSuccess = false
          this.changeLoadingState(false)
        })
    }
  },
  filters: {
    formatarDataSolicitacao(value) {
      if (!value) return ''
      return format(new Date(value), 'dd/MM/yyyy')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/forms';
@import '~@/assets/stylesheets/warnings';

.container-sarah {
  background-color: white;
}

.mensagem-sucesso {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  h1 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 1rem;
  }
}
.mensagem-erro {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  h1 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 1rem;
  }
}

.issue-certificate {
  background-color: var(--gray-100);
  .container {
    height: 100%;
  }
  .general-forms {
    background-color: var(--bg-color-primary);
    margin-top: 1rem;
    max-height: 80vh;
    min-height: 20rem;
    height: 100%;
    padding: 1.5rem;
    .intro {
      font-size: 1rem;
      margin-bottom: 1.7rem;
      line-height: 1.3;
      max-width: 80%;
    }
    .select-form {
      margin-bottom: 2.5rem;
    }
  }
  .field {
    max-width: 80%;
    min-width: 80%;
  }
  .warning {
    max-width: 80%;
  }
}
@media (max-width: $mobile-width-breakpoint) {
  .issue-certificate {
    .general-forms {
      max-height: 100%;
      padding-bottom: 3rem;
      .intro {
        max-width: 100%;
      }
      .select-form .dropdown {
        .dropdown-trigger {
          width: 100%;
        }
        .dropdown-menu {
          width: 100%;
        }
      }
    }
    .textarea {
      max-width: 100%;
    }
    .warning {
      max-width: 100%;
    }
  }
}
</style>
